import { useFormContext } from 'react-hook-form';
import { DestructiveButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';
import { useEditStateContext } from '../../contexts/EditStateContext';
import { FrequencyManagementSchema } from '../../contexts/FormProvider';

export const DISCARD_CHANGES_MODAL_ID = 'freq-manage-discard-changes-modal';

export const DiscardChangesModal = () => {
  const { modalState, hideModal } = useModalContext();
  const { clearEditState } = useEditStateContext();
  const { reset } = useFormContext<FrequencyManagementSchema>();

  if (modalState !== DISCARD_CHANGES_MODAL_ID) return null;

  const onConfirm = () => {
    clearEditState();
    reset();
    hideModal();
  };

  return (
    <Modal
      id={DISCARD_CHANGES_MODAL_ID}
      data-test={DISCARD_CHANGES_MODAL_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      onClose={hideModal}
      isModalOpen
      withPortal
    >
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalBody>
        <Body2>
          This page has unsaved changes. Are you sure you want to discard those changes?
        </Body2>
      </ModalBody>
      <ModalFooter hasCancel onClose={hideModal}>
        <DestructiveButton onClick={onConfirm}>Discard changes</DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
